import { useSelector } from 'react-redux'
import { ToastContainer as LibToastContainer } from 'react-toastify'
import { RootState } from '../../store/modules/rootReducer'
import { CustomToastStyles } from './styles'

const ToastContainer = () => {
  const { isDarkMode } = useSelector((state: RootState) => state.theme)

  return (
    <CustomToastStyles>
      <LibToastContainer theme={isDarkMode ? 'dark' : 'colored'} />
    </CustomToastStyles>
  )
}

export default ToastContainer
